import { useEffect, EffectCallback } from "react";

export function useEffectOnMount(callback: EffectCallback): void {
  useEffect(callback, []);
}
